// extracted by mini-css-extract-plugin
export var phone = "_2l-0";